export const initNativeShareBox = (config = {
        shareButton: '.share-button',
        shareDialog: '.share-dialog',
        closeButton: '.close-button',
        title: 'TinyTap Game',
        url: 'https://www.tinytap.com'
    }) => {
    const shareButton = document.querySelector(config.shareButton);
    if(!navigator.share) { 
        shareButton.style.display = "none";
        return;
    }
    const shareDialog = document.querySelector(config.shareDialog);
    const closeButton = document.querySelector(config.closeButton);
        
    if(!shareButton) return;
    shareButton.addEventListener('click', () => {
        if (navigator.share) { 
            navigator.share({
                title: config.title,
                url: config.url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        } else {
            if(!shareDialog) return;
            shareDialog.classList.add('is-open');
        }
        if(window.sendGA4Event){
            sendGA4Event('share_button_click', { albumId: window.albumId })
        }
    });
    
    if(!closeButton) return;
    closeButton.addEventListener('click', () => {
        shareDialog.classList.remove('is-open');
    });
}